export default __webpack_public_path__ + "static/pharma-09a6defbe18033529d047a7cad1ac408.png";